import type { IPushTokenApi, IPushTokenData } from "push-notifications";

interface IDriveApi {
    call(method: string, params: object, success: (result: any) => void, failure: (error: any) => void): void;
}

export class DriveApiPushTokenAdapter implements IPushTokenApi {
    constructor(private readonly api: IDriveApi) {}

    async addPushToken(entity: IPushTokenData): Promise<string> {
        return new Promise((resolve, reject) => {
            this.api.call("Add", {
                typeName: "PushToken",
                entity
            }, (id: string) => resolve(id), (error: any) => reject(error));
        });
    }

    async removePushToken(entity: { id?: string; token?: string }): Promise<void> {
        return new Promise((resolve, reject) => {
            this.api.call("Remove", {
                typeName: "PushToken",
                entity
            }, () => resolve(), (error: any) => reject(error));
        });
    }

    async getPushTokensForUser(userId: string): Promise<IPushTokenData[]> {
        return new Promise((resolve, reject) => {
            this.api.call("Get", {
                typeName: "PushToken",
                search: { userSearch: { id: userId } }
            }, (tokens: IPushTokenData[]) => resolve(tokens), (error: any) => reject(error));
        });
    }
}
